import { useState, useEffect } from 'react';
import { getUserGames } from '@/entities/user/api/userApi.js';
import { getUserProfile } from '@/entities/user/api/userApi.js';
import { PAGE_SIZE_DESKTOP, PAGE_SIZE_MOBILE } from './const.js';
import {useUser} from "@/entities/user/model/UserContext.jsx";
import useIsMobile from "@/shared/lib/hooks/useIsMobile.jsx";
import { generateTelegramCode } from "@/features/Profile/api/generateTelegramCode.js";
import {toast} from "react-toastify";

export default function useProfileData() {
    const isMobile = useIsMobile();
    const {user, setUser} = useUser();
    const [games, setGames] = useState([]);
    const [page, setPage]   = useState(0);
    const [lastPage, setLastPage] = useState(false);
    const [loading, setLoading]   = useState({ user: true, games: false });
    const [totalEls, setTotalEls] = useState(0);
    const pageSize = isMobile ? PAGE_SIZE_MOBILE : PAGE_SIZE_DESKTOP;
    const [isCodePending, setIsCodePending] = useState(false);

    /* загрузка профиля */
    useEffect(() => {
        (async () => {
            try {
                const res = await getUserProfile();
                setUser(res.data);
            } finally {
                setLoading((l) => ({ ...l, user: false }));
            }
        })();
    }, []);

    /* первая партия игр  */
    useEffect(() => { loadGames(); }, []);

    const loadGames = async () => {
        if (loading.games || lastPage) return;
        try {
            setLoading((l) => ({ ...l, games: true }));
            const res = await getUserGames(page, pageSize);
            const d = res.data;
            setGames((prev) => [...prev, ...d.content]);
            setTotalEls(d.totalElements)
            setPage((p) => p + 1);
            setLastPage(d.last);
        } finally {
            setLoading((l) => ({ ...l, games: false }));
        }
    };

    const generateCode =  async () => {
        setIsCodePending(true);
        try {
            const res = await generateTelegramCode();
            console.log(res.data);
            setUser(prev => ({...prev ,telegramCode: res.data}));
        } catch (e){
            toast.error(e.response.data.message || "Ошибка");
        }finally {
            setIsCodePending(false);
        }
    }

    return {
        user,
        games,
        totalElements: totalEls ,
        loadingUser: loading.user,
        loadingGames: loading.games,
        lastPage,
        loadGames,
        setUser,               // отдадим наружу для logout
        generateCode,
        isCodePending
    };
}
